import axios from 'axios'

export class CategorieApi {
  private m_instance: any

  public constructor() {
    this.m_instance = axios.create({
      // baseURL: 'https://api.prod.photos-presse.com/category',
      baseURL: 'https://api.photos-presse.com/category',
      // baseURL: 'https://enlbpyawnd.execute-api.us-east-1.amazonaws.com'
    })
  }

  public updateBaseUrl(baseUrl: string): void {
    console.log('updateBaseUrl')

    this.m_instance.defaults.baseURL = baseUrl
  }

  public updateAuthorization(token: string): void {
    console.log('updateAuthorization')

    this.m_instance.defaults.headers.common['Authorization'] = token
  }

  public get(): Promise<JSON> {
    console.log('get')

    return this.m_instance.get('/')
  }
}
